<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-06-28 13:39:27
-->
<template>
  <div class="loading-oia-canvas">
    <div class="loading-oia-spinner"></div>
  </div>
</template>

<script>
export default {
  props: ["msg"],
  data: function () {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
.loading-oia-canvas {
  align-items: center;
  background: #eeeeee;
  border-radius: 50%;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  display: flex;
  height: 62px !important;
  justify-content: center;
  width: 62px !important;

  /* Spinner 5 starts here */
  .loading-oia-spinner {
    animation: spinnerFive 1s linear infinite;
    border: solid 18px #409eff;
    border-right: solid 18px transparent;
    border-left: solid 18px transparent;
    border-radius: 100%;
    width: 0;
    height: 0;
  }

  @keyframes spinnerFive {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(60deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  /* Spinner 5 ends here */
}
</style>